export class MIRulesCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria(params) {
    return this.#http.get('/api/mi-rule', { params });
  }

  async createCriteria(body) {
    return this.#http.post('/api/mi-rule', body);
  }

  async editCriteria({ criteriaId, ...body }) {
    return this.#http.put(`/api/mi-rule/${criteriaId}`, body);
  }

  async deleteCriteria({ ruleId }) {
    return this.#http.delete(`/api/mi-rule/${ruleId}`);
  }

  async disableGlobalMiRule({ ruleId }) {
    return this.#http.post(`/api/mi-rule/${ruleId}/disable`);
  }

  async enableGlobalMiRule({ ruleId }) {
    return this.#http.post(`/api/mi-rule/${ruleId}/enable`);
  }

  async cloneGlobalMiRule({ ruleId }) {
    return this.#http.post(`/api/mi-rule/${ruleId}/clone`);
  }
}
